import { useEffect, useState } from "react";
import { cdnGetRequest } from "../../utils/webrequests";
import { EventInfo } from "../../data/eventInfo";

export async function getEventById(Id: string):Promise<EventInfo> {
    const data:EventInfo = await cdnGetRequest(`cdn-data/events/${Id}.json`);
    return data;
  }